<template>
  <div class="ACCUEIL" data-model-id="2:2162">
    <NavSubsection />
    <ContainerSubsection />
    <FrameWrapperSubsection />
    <ContainerWrapperSubsection />
    <DivWrapperSubsection />
    <DivSubsection />
    <SectionComponentNodeSubsection />
    <Container1Subsection />
    <FooterSubsection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavSubsection from "./Accueil/sections/NavSubsection/NavSubsection.vue";
import ContainerSubsection from "./Accueil/sections/ContainerSubsection.vue";
import FrameWrapperSubsection from "./Accueil/sections/FrameWrapperSubsection.vue";
import ContainerWrapperSubsection from "./Accueil/sections/ContainerWrapperSubsection.vue";
import DivWrapperSubsection from "./Accueil/sections/DivWrapperSubsection.vue";
import DivSubsection from "./Accueil/sections/DivSubsection.vue";
import SectionComponentNodeSubsection from "./Accueil/sections/SectionComponentNodeSubsection.vue";
import Container1Subsection from "./Accueil/sections/Container1Subsection.vue";
import FooterSubsection from "./Accueil/sections/FooterSubsection/FooterSubsection.vue";

export default defineComponent({
  name: "Accueil",
  components: {
    NavSubsection,
    ContainerSubsection,
    FrameWrapperSubsection,
    ContainerWrapperSubsection,
    DivWrapperSubsection,
    DivSubsection,
    SectionComponentNodeSubsection,
    Container1Subsection,
    FooterSubsection,
  },
});
</script>

<style>
.ACCUEIL {
  align-items: center;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  position: relative;
}

@media (max-width: 1024px) {
  .ACCUEIL :is(
      .container-subsection,
      .frame-wrapper-subsection,
      .container-wrapper-subsection,
      .div-wrapper-subsection,
      .div-subsection,
      .section-component-node-subsection,
      .container-1-subsection
    ) {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .ACCUEIL :is(
      .frame,
      .div,
      .container,
      [class*="wrapper"],
      [class*="frame-"],
      [class*="container-"]
    ) {
    min-width: 0 !important;
    max-width: 100% !important;
  }
}

@media (max-width: 768px) {
  .ACCUEIL :is(
      .container-subsection,
      .frame-wrapper-subsection,
      .container-wrapper-subsection,
      .div-wrapper-subsection,
      .div-subsection,
      .section-component-node-subsection,
      .container-1-subsection
    ) {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
</style>
